var map = {
	"./": 17,
	"./development": 181,
	"./development.js": 181,
	"./i18n": 127,
	"./i18n.js": 127,
	"./index": 17,
	"./index.js": 17,
	"./production": 182,
	"./production.js": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 295;